import * as React from 'react';
import { Table, TableContainer } from '@mui/material';

export const TableContentWrapper: React.FC<{ children: React.ReactNode }> = (props) => {

    return (
        <TableContainer>
            <Table
                sx={{ minWidth: 750 }}
                aria-labelledby="tableTitle"
                size={'medium'}
            >
                {props.children}
            </Table>
        </TableContainer>
    );
};
